import { render, staticRenderFns } from "./SectionQuestions.vue?vue&type=template&id=f05b887c&scoped=true&"
import script from "./SectionQuestions.vue?vue&type=script&lang=js&"
export * from "./SectionQuestions.vue?vue&type=script&lang=js&"
import style0 from "./SectionQuestions.vue?vue&type=style&index=0&id=f05b887c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f05b887c",
  null
  
)

export default component.exports